import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getAdminPartnerInvitationSummary } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import {
	AdminPartnerInvitationSummaryRequest,
	AdminPartnerInvitationSummaryResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetAdminPartnerInvitationSummary(
	partnerId: string,
	payload?: AdminPartnerInvitationSummaryRequest,
	props?: UseBaseQueryOptions<AdminPartnerInvitationSummaryResponse>,
) {
	return useQuery({
		queryKey: [
			PartnerQueryKeys.GetAdminPartnerInvitationSummary,
			partnerId,
			payload,
		],
		queryFn: () => getAdminPartnerInvitationSummary(partnerId, payload),
		enabled: !!partnerId,
		...props,
	})
}
